export const UI_BEHAVIOUR_OPEN_MAP = 'OPEN_MAP';

export const UI_INTEGRATION_REGEX = new RegExp(/\$\$([A-Z0-9_]+)\s*([A-Za-z0-9,. ]*)\$\$/);